/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Ad_Import_FailedInputs */

const en_ad_import_failed = /** @type {(inputs: Ad_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to import AD project: ${i?.error}`)
};

const fr_ad_import_failed = /** @type {(inputs: Ad_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l'importation du projet AD : ${i?.error}`)
};

const de_ad_import_failed = /** @type {(inputs: Ad_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AD-Projekt konnte nicht importiert werden: ${i?.error}`)
};

const it_ad_import_failed = /** @type {(inputs: Ad_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile importare il progetto AD: ${i?.error}`)
};

const ru_ad_import_failed = /** @type {(inputs: Ad_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось импортировать проект AD: ${i?.error}`)
};

const es_ad_import_failed = /** @type {(inputs: Ad_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al importar el proyecto AD: ${i?.error}`)
};

const zh_cn2_ad_import_failed = /** @type {(inputs: Ad_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导入 AD 项目失败：${i?.error}`)
};

const ja_ad_import_failed = /** @type {(inputs: Ad_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ADプロジェクトのインポートに失敗しました: ${i?.error}`)
};

const hi_ad_import_failed = /** @type {(inputs: Ad_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AD प्रोजेक्ट आयात करने में विफल: ${i?.error}`)
};

const pt_pt2_ad_import_failed = /** @type {(inputs: Ad_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao importar o projeto AD: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to import AD project: {error}" |
*
* @param {Ad_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_import_failed = /** @type {((inputs: Ad_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_import_failed(inputs)
	if (locale === "de") return de_ad_import_failed(inputs)
	if (locale === "it") return it_ad_import_failed(inputs)
	if (locale === "ru") return ru_ad_import_failed(inputs)
	if (locale === "es") return es_ad_import_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_import_failed(inputs)
	if (locale === "ja") return ja_ad_import_failed(inputs)
	if (locale === "hi") return hi_ad_import_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_import_failed(inputs)
	return en_ad_import_failed(inputs)
});